import React, { memo, useEffect } from 'react';
import { Col, Form, Input, Modal, Row, Switch, Button, Card } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { onFinishFailed } from './DisplayValidationErrors/DisplayValidationErrors';
import { ParPagComponentRequest } from 'services/displayFramework';
import { shouldUpdateCompare } from 'utils/utils2';
import ISave from 'icons/ISave';

export type ComcodeConfigModalProps = {
  visible: boolean;
  onCancel: () => void;
  onSave: (values: ComcodeConfigModalProps) => void;
  preset: ParPagComponentRequest;
};
const initialValues = {
  comcode: '',
  comformat: '',
  comhint: '',
  comlabel: '',
  commessage: '',
  complaceholder: '',
  comrequired: '',
  comstyle: '',
  comtype: '',
  pagcode: '',
};

const ComcodeConfigModal = (props: ComcodeConfigModalProps) => {
  const { visible, onCancel, preset, onSave } = props;
  const [form] = useForm();

  useEffect(() => {
    form.setFieldsValue({ ...preset });
  }, [visible]);

  const handleFinish = (values: any) => {
    onSave({ ...initialValues, ...values });
    onCancel();
  };

  return (
    (<Modal
      open={visible}
      footer={null}
      onCancel={onCancel}
      centered
      width={800}
    >
      <Card>
        <Form
          form={form}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          layout="horizontal"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
        >
          <Row gutter={32}>
            <Col span={8}>
              <Form.Item label="Comcode" name="comcode">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Label" name="comlabel">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Style" name="comstyle">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={32}>
            <Col span={8}>
              <Form.Item label="Format" name="comformat">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Place Holder" name="complaceholder">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Hint" name="comhint">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={32}>
            <Col span={8}>
              <Form.Item
                label="Required"
                name="comrequired"
                valuePropName="checked"
              >
                <Switch style={{ width: '50%' }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                shouldUpdate={shouldUpdateCompare('comrequired')}
                noStyle
              >
                {({ getFieldValue }) =>
                  getFieldValue('comrequired') === true && (
                    <Form.Item label="Message" name="commessage">
                      <Input />
                    </Form.Item>
                  )
                }
              </Form.Item>
            </Col>
            <Button
              size="large"
              icon={<ISave color="white" />}
              style={{ marginTop: '5%', marginLeft: '10%' }}
              type="primary"
              htmlType="submit"
            >
              Save
            </Button>
          </Row>
        </Form>
      </Card>
    </Modal>)
  );
};

export default memo(ComcodeConfigModal);
